<template>
  <el-select
    v-model="dataValue"
    placeholder="请选择试题题型"
    @change="onChange">
    <el-option
      label="全部"
      :value="null"></el-option>
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
import { questionType } from './index'
export default {
  name: 'QuestionTypeSelect',
  props: {
    value: { type: [Number, null], default: null }
  },
  data() {
    return {
      list: questionType
    }
  },
  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange(e) {
      this.$emit('change', e)
    }
  }
}
</script>
